var _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScreenshare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M10.878,90.777h76.616c4.225,0,7.662-3.66,7.662-8.156V70.389H56.848v4.076H41.524v-4.076H3.216v12.232 C3.216,87.117,6.655,90.777,10.878,90.777z M87.494,82.621H60.68v-4.078h26.814V82.621z M10.878,78.543h26.815v4.078H10.878V78.543 z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M91.324,66.311V17.378c0-4.5-3.438-8.156-7.66-8.156H14.709c-4.224,0-7.662,3.655-7.662,8.156v48.932h7.662 V17.378h68.955v48.932H91.324z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M61.803,39.757l10.04-11.272l-13.25-7.408l-2.941,3.406l6.305,3.522 c-18.216,4.597-29.36,22.918-30.288,35.494l4.896-0.033c0.83-11.18,10.539-27.397,26.28-31.492l-4.926,5.532L61.803,39.757z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenshare);
export default __webpack_public_path__ + "static/media/screenshare.e189e14523608b81c20c88e5e5e7f5c0.svg";
export { ForwardRef as ReactComponent };